import styled from 'styled-components'

import { helpers } from 'styles'

import { Container as DefaultContainer } from './Container'

export const IconContainer = styled(DefaultContainer)`
	display: flex;
	align-items: center;
	justify-content: center;
	flex-direction: column;
	text-align: center;
	row-gap: ${helpers.spacing.large};
`
